export default [

  // Dashboard
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Index.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  // Alerts
  {
    path: '/alerts-history',
    name: 'alerts-history',
    component: () => import('@/views/alerts/history/List.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/alerts-config',
    name: 'alerts-config',
    component: () => import('@/views/alerts/config/List.vue'),
    meta: {
      resource: 'Tech',
      action: 'read',
    },
  },
]
